<div class="topbar">
  <div>
    <h1>Overblik</h1>
  </div>
  <div class="topbar__actions"></div>
</div>
